import { BaseResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";

export interface FeatureAccessLevel {
	readonly id: string;
	readonly level: number;
}

export const AccessLevels = {
	None: -1,
	NotSet: 0,
	Hide: 1,
	View: 2,
	Edit: 3,
	Full: 4
} as const;

export type AccessLevel = typeof AccessLevels[keyof typeof AccessLevels];

export class FeatureAccessLevelResource
	extends BaseResource
	implements FeatureAccessLevel
{
	readonly id: string;
	readonly level: AccessLevel;

	pk() {
		return this.id.toString();
	}

	static urlRoot = apiResourceUrl("access-levels");
}
